import { Search211PhoneNumber } from '../../definitions'

/**
 * Format phone numbers array into string.
 * @param  {Search211PhoneNumber[]} phoneNumbers
 *
 * @return {string}
 */
export const formatPhone = (phoneNumbers) => {
  const phoneOnly = phoneNumbers.map((phone) => phone.Phone)
  return phoneOnly.join(', ')
}

/**
 * Format website URL.
 * @param {string} url
 * @return {string}
 */
export const formatUrl = (url) => {
  if (url.includes('http')) {
    return url
  }

  return `https://${url}`
}

/**
 * Format website URL.
 * @param {string} mail
 * @return {string}
 */
export const formatEmail = (mail) => {
  return `mailto:${mail}`
}

/**
 * Compose result item detail path page.
 * @param {number} resultId
 * @return {string}
 */
export const detailPath = (resultId) => {
  return `/result/view/${resultId}`
}

/**
 * Compose Google directions URL.
 * @param {number} lat
 * @param {number} lon
 * @return {string}
 */
export const directionsUrl = (lat, lon) => {
  return `https://www.google.ca/maps?q=${lat},${lon}`
}
